<template>
	<div>
		<div v-if="!loading">
			<b-button-toolbar class="float-md-right d-print-none">
				<b-button-group class="mx-1">
					<b-button variant="outline-secondary" @click="changeFontSize(-0.5)">–</b-button>
					<b-button variant="outline-secondary" @click="resetFontSize()">Reset</b-button>
					<b-button variant="outline-secondary" @click="changeFontSize(0.5)">+</b-button>
				</b-button-group>
				<b-button-group class="mx-1">
					<b-button variant="outline-secondary" @click="print()">Print</b-button>
				</b-button-group>
				<b-form-radio-group buttons
														v-model="language"
														:options="song.languages" style="text-transform: uppercase"/>
				<router-link class="btn mx-1" :class="{'btn-outline-secondary': !song.hasFile, 'btn-outline-success': song.hasFile}" :to="{name: 'sheet', params: {id: id}}">Notes</router-link>
				<b-button-group class="mx-1">
					<b-button variant="outline-primary" @click="edit()">Edit</b-button>
					<b-button variant="outline-secondary" @click="close()">Close</b-button>
				</b-button-group>

			</b-button-toolbar>


			<h1>{{song.lyrics[language].title}}</h1>
			<h4 class="text-muted">{{song.tags.map(tag => "#" + tag).join(", ")}}</h4>
			<div :style="'font-size: ' + fontSize + 'pt'">
				<p>{{song.lyrics[language].lines}}</p>
			</div>
		</div>
		<div v-else>Loading...</div>
	</div>
</template>

<script>
	import axios from '../ConfiguredAxios'

	let initialFontSize = 15

	export default {
		name: 'lyrics',
		data: function () {
			return {
				loading: true,
				fontSize: initialFontSize,
				song: {
					id: this.$route.params.id,
					lyrics: {},
					languages: [],
					hasFile: false
				}
			}
		},
		computed: {
			language: {
				get: function () {
					return this.$route.params.lang
				},
				set: function (newValue) {
					this.$router.push({params: {lang: newValue}})
				}
			},
			id: function () {
				return this.$route.params.id
			}
		},
		created: function () {
			this.load(this.id)
		},
		methods: {
			load: function (id) {
				this.loading = true
				axios.get("/rest/v1/songs/" + id).then(response => {
					this.song = response.data
					this.song.languages = Object.keys(response.data.lyrics)
					this.loading = false
				})
			},
			edit: function () {
				this.$router.push({
					name: "edit", params: {
						id: this.id,
						lang: this.language
					}
				})
			},
			close: function () {
				this.$router.push({
					name: "list"
				})
			},
			changeFontSize: function(difference) {
				this.fontSize += difference
			},
			resetFontSize: function() {
				this.fontSize = initialFontSize
			},
			print: function () {
				window.print()
			}
		},
		watch: {
			'$route'(to, from) {
				this.load(to.params.id)
			}
		}
	}
</script>


<style scoped>
	p {
		white-space: pre-line;
		column-width: 21em;
		column-count: 2;
		column-gap: 2em;
		column-rule: 1px solid #ccc;
	}

	@media print {
		p {
			column-count: 2;
			-moz-column-count: 2;
			-webkit-column-count: 2;
			column-rule: none;
			-moz-column-rule: none;
			-webkit-column-rule: none;
		}
	}
</style>
